export default __webpack_public_path__ + "images/UD.fd3d6e8.png";